module.exports = __webpack_public_path__ + "static/media/PORTFOLIO3.6357a9f8.png";